import React,{Component} from 'react';

import Container from '../../components/Container';
import Heading from '../../components/Heading';
import UsersChangesTable from './components/UsersChangesTable';
import Popup from './components/Popup';

import API from '../../services/API';

class UsersChanges extends Component {
    constructor() {
        super();

        this.state = {
            stats: [],
            isLoading: false,
            daySubscribeStats: null
        };

        this.handleDateClick = this.handleDateClick.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
        this.handlePopupHide = this.handlePopupHide.bind(this);
    }

    componentDidMount() {
        this.loadStats();
    }

    loadStats() {
        this.setState({
            isLoading: true
        });

        API.Stats.get()
        .then(res => {
            this.setState({
                stats: res.stats ? res.stats : [],
                isLoading: false
            });
        });
    }

    loadDaySubscribeStats(day) {
        this.setState({
            isLoading: true
        });

        API.Users.getDaySubscribeStats(day)
        .then(res => {
            this.setState({
                daySubscribeStats: res,
                isLoading: false
            });
        });
    }

    getPopup() {
        if(this.state.daySubscribeStats) {
            return (
                <Popup
                    onHide={this.handlePopupHide}
                    stats={this.state.daySubscribeStats}
                />
            );
        }
    }

    handleDateClick() {
        this.setState({
            stats: this.state.stats.reverse()
        });
    }

    handleRowClick(day) {
        this.loadDaySubscribeStats(day);
    }

    handlePopupHide() {
        this.setState({
            daySubscribeStats: null
        });
    }


    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Users Changes"/>
                {this.getPopup()}
                <UsersChangesTable
                    data={this.state.stats}
                    onDateClick={this.handleDateClick}
                    onRowClick={this.handleRowClick}
                />
            </Container>
        );
    }
}

export default UsersChanges;


// WEBPACK FOOTER //
// ./src/scenes/UsersChanges/index.js